<template>
  <PartnersLayout>
    <template #header>
      <PartnersHeader
        title="내 점프 관리"
        subtitle="점프 신청 내역 및 현황"
      />
    </template>

    <div class="px-4 lg:px-6 pb-6">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- 왼쪽: 요약 & 바로가기 -->
          <div class="lg:col-span-1 space-y-4">
            <!-- 현재 상태 카드 -->
            <div class="bg-white border border-slate-200 rounded-2xl p-5">
            <div class="flex items-center gap-3 mb-4">
              <div class="w-10 h-10 bg-violet-500/10 rounded-xl flex items-center justify-center">
                <svg class="w-5 h-5 text-violet-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                </svg>
              </div>
              <div>
                <h3 class="font-bold text-slate-800">점프 현황</h3>
                <p class="text-xs text-slate-500">총 {{ myJumps.length }}개 점프</p>
              </div>
            </div>

            <div class="grid grid-cols-3 gap-3">
              <div class="text-center p-3 bg-green-50 rounded-xl">
                <p class="text-xl font-bold text-green-600">{{ activeCount }}</p>
                <p class="text-xs text-green-600">활성</p>
              </div>
              <div class="text-center p-3 bg-slate-50 rounded-xl">
                <p class="text-xl font-bold text-slate-600">{{ expiredCount }}</p>
                <p class="text-xs text-slate-600">종료</p>
              </div>
              <div class="text-center p-3 bg-red-50 rounded-xl">
                <p class="text-xl font-bold text-red-600">{{ cancelledCount }}</p>
                <p class="text-xs text-red-600">취소</p>
              </div>
            </div>
          </div>

          <!-- 활성 점프 안내 -->
          <div v-if="activeJumpInfo" class="bg-violet-50 border border-violet-200 rounded-2xl p-5">
            <div class="flex items-center gap-2 mb-3">
              <svg class="w-5 h-5 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
              </svg>
              <span class="font-bold text-violet-800">현재 활성 점프</span>
            </div>
            <div class="space-y-2 text-sm">
              <div class="flex justify-between">
                <span class="text-violet-600">현장</span>
                <span class="font-medium text-violet-800">{{ activeJumpInfo.propertyName }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-violet-600">시간대</span>
                <span class="font-medium text-violet-800">{{ activeJumpInfo.timeSlot?.label }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-violet-600">종료일</span>
                <span class="font-medium text-violet-800">{{ formatDateShort(activeJumpInfo.endDate) }}</span>
              </div>
            </div>
          </div>

            <!-- 바로가기 -->
            <div class="bg-white border border-slate-200 rounded-2xl p-4">
              <p class="text-[12px] font-bold text-slate-500 mb-3">바로가기</p>
            <div class="space-y-2">
              <router-link
                to="/partners/jump/purchase"
                class="flex items-center justify-between p-3 bg-violet-50 rounded-xl hover:bg-violet-100 transition"
              >
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 bg-violet-100 rounded-lg flex items-center justify-center">
                    <svg class="w-4 h-4 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                    </svg>
                  </div>
                  <span class="text-[13px] font-medium text-violet-700">점프 신청하기</span>
                </div>
                <svg class="w-4 h-4 text-violet-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
              </router-link>
              <router-link
                to="/partners/jump/stats"
                class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition"
              >
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                    </svg>
                  </div>
                  <span class="text-[13px] font-medium text-slate-700">점프 효과 통계</span>
                </div>
                <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
              </router-link>
              <router-link
                to="/partners/leads/banner"
                class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition"
              >
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
                    <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                    </svg>
                  </div>
                  <span class="text-[13px] font-medium text-slate-700">광고 유입 콜</span>
                </div>
                <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
              </router-link>
              </div>
            </div>
          </div>

          <!-- 오른쪽: 점프 목록 -->
          <div class="lg:col-span-2">
            <div class="bg-white border border-slate-200 rounded-2xl overflow-hidden">
            <div class="p-5 border-b border-slate-100">
              <h2 class="text-lg font-bold text-slate-800">점프 내역</h2>
              <p class="text-sm text-slate-500 mt-1">전체 점프 신청 내역을 확인하세요</p>
            </div>

            <!-- 로딩 -->
            <div v-if="loading" class="flex justify-center py-12">
              <div class="w-10 h-10 border-4 border-violet-500/30 border-t-violet-500 rounded-full animate-spin"></div>
            </div>

            <!-- 빈 상태 -->
            <div v-else-if="myJumps.length === 0" class="p-12 text-center">
              <div class="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg class="w-8 h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-slate-700 mb-2">점프 내역이 없습니다</h3>
              <p class="text-slate-500 mb-6">점프를 신청하여 상단에 노출되세요!</p>
              <router-link
                to="/partners/jump/purchase"
                class="inline-flex items-center gap-2 px-6 py-3 bg-violet-600 text-white font-medium rounded-xl hover:bg-violet-700 transition"
              >
                점프 신청하기
              </router-link>
            </div>

            <!-- 점프 목록 -->
            <div v-else class="divide-y divide-slate-100">
              <div
                v-for="jump in myJumps"
                :key="jump.id"
                class="p-5"
              >
                <div class="flex items-start justify-between mb-3">
                  <div>
                    <div class="flex items-center gap-2 mb-1">
                      <h3 class="font-bold text-slate-800">{{ jump.propertyName }}</h3>
                      <span :class="getStatusBadgeClass(getJumpStatus(jump))">
                        {{ getStatusLabel(getJumpStatus(jump)) }}
                      </span>
                    </div>
                    <p class="text-sm text-slate-500">
                      {{ formatDateShort(jump.startDate) }} ~ {{ formatDateShort(jump.endDate) }}
                    </p>
                  </div>
                  <div class="text-right">
                    <span class="px-3 py-1 text-sm font-medium bg-green-100 text-green-700 rounded-full">무료</span>
                  </div>
                </div>

                <!-- 시간대 표시 -->
                <div class="mb-4">
                  <span class="px-3 py-1 text-xs bg-violet-50 text-violet-600 rounded-full">
                    {{ jump.timeSlot?.label || `${jump.timeSlot?.start} ~ ${jump.timeSlot?.end}` }}
                  </span>
                </div>

                <!-- 상태별 정보 및 액션 -->
                <div class="flex items-center justify-between pt-3 border-t border-slate-100">
                  <div>
                    <p v-if="getJumpStatus(jump) === 'active' && !isStarted(jump)" class="text-sm text-green-600">
                      {{ getDaysUntilStart(jump) }}일 후 시작
                    </p>
                    <p v-else-if="getJumpStatus(jump) === 'active'" class="text-sm text-violet-600">
                      현재 진행 중 ({{ getRemainingDays(jump) }}일 남음)
                    </p>
                    <p v-else-if="getJumpStatus(jump) === 'expired'" class="text-sm text-slate-400">
                      {{ formatDate(jump.endDate) }} 종료
                    </p>
                    <p v-else-if="getJumpStatus(jump) === 'cancelled'" class="text-sm text-red-500">
                      취소됨
                    </p>
                  </div>

                  <div class="flex gap-2">
                    <router-link
                      :to="`/partners/jump/stats?id=${jump.id}`"
                      class="px-4 py-2 text-sm text-violet-600 bg-violet-50 rounded-lg hover:bg-violet-100 transition"
                    >
                      통계 보기
                    </router-link>
                    <!-- 시작 전 active: 취소하기, 그 외: 삭제 -->
                    <button
                      v-if="getJumpStatus(jump) === 'active' && !isStarted(jump)"
                      @click="handleCancel(jump)"
                      class="px-4 py-2 text-sm text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition"
                    >
                      취소하기
                    </button>
                    <button
                      v-else
                      @click="handleDelete(jump)"
                      class="px-4 py-2 text-sm text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition"
                    >
                      삭제
                    </button>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PartnersLayout>
</template>

<script>
import { computed, onMounted } from 'vue'
import PartnersLayout from '@/components/partners/common/PartnersLayout.vue'
import PartnersHeader from '@/components/partners/common/PartnersHeader.vue'
import { useJump } from '@/composables/partners/useJump'

export default {
  name: 'MyJumpListView',
  components: {
    PartnersLayout,
    PartnersHeader
  },
  setup() {
    const {
      myJumps,
      loading,
      loadMyJumps,
      cancelJump,
      deleteJump,
      getJumpStatus,
      getKoreanTime
    } = useJump()

    // 상태별 카운트
    const activeCount = computed(() => {
      return myJumps.value.filter(j => getJumpStatus(j) === 'active').length
    })

    const expiredCount = computed(() => {
      return myJumps.value.filter(j => getJumpStatus(j) === 'expired').length
    })

    const cancelledCount = computed(() => {
      return myJumps.value.filter(j => getJumpStatus(j) === 'cancelled').length
    })

    // 현재 활성 점프 정보
    const activeJumpInfo = computed(() => {
      const { date: today } = getKoreanTime()
      return myJumps.value.find(j =>
        getJumpStatus(j) === 'active' &&
        j.startDate <= today &&
        j.endDate >= today
      )
    })

    const getStatusLabel = (status) => {
      const labels = {
        active: '활성',
        expired: '종료',
        cancelled: '취소됨'
      }
      return labels[status] || status
    }

    const getStatusBadgeClass = (status) => {
      const classes = {
        active: 'px-2 py-0.5 text-xs font-medium bg-green-100 text-green-700 rounded-full',
        expired: 'px-2 py-0.5 text-xs font-medium bg-slate-100 text-slate-600 rounded-full',
        cancelled: 'px-2 py-0.5 text-xs font-medium bg-red-100 text-red-600 rounded-full'
      }
      return classes[status] || classes.active
    }

    const isStarted = (jump) => {
      const { date: today } = getKoreanTime()
      return jump.startDate <= today
    }

    const getDaysUntilStart = (jump) => {
      const { date: today } = getKoreanTime()
      const todayDate = new Date(today)
      const startDate = new Date(jump.startDate)
      return Math.ceil((startDate - todayDate) / (1000 * 60 * 60 * 24))
    }

    const getRemainingDays = (jump) => {
      const { date: today } = getKoreanTime()
      const todayDate = new Date(today)
      const endDate = new Date(jump.endDate)
      return Math.ceil((endDate - todayDate) / (1000 * 60 * 60 * 24)) + 1
    }

    const formatDateShort = (dateStr) => {
      if (!dateStr) return ''
      const [, m, d] = dateStr.split('-')
      return `${parseInt(m)}/${parseInt(d)}`
    }

    const formatDate = (dateStr) => {
      if (!dateStr) return ''
      return new Date(dateStr).toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }

    const handleCancel = async (jump) => {
      if (!confirm('점프를 취소하시겠습니까?\n\n* 시작 전에만 취소 가능합니다.')) {
        return
      }

      const result = await cancelJump(jump.id)

      if (result.success) {
        alert('취소 완료!')
        await loadMyJumps()
      } else {
        alert('취소 실패: ' + result.error)
      }
    }

    const handleDelete = async (jump) => {
      if (!confirm('점프 기록을 삭제하시겠습니까?\n\n* 삭제된 기록은 복구할 수 없습니다.')) {
        return
      }

      const result = await deleteJump(jump.id)

      if (result.success) {
        alert('삭제 완료!')
        await loadMyJumps()
      } else {
        alert('삭제 실패: ' + result.error)
      }
    }

    onMounted(() => {
      loadMyJumps()
    })

    return {
      myJumps,
      loading,
      activeCount,
      expiredCount,
      cancelledCount,
      activeJumpInfo,
      getJumpStatus,
      getStatusLabel,
      getStatusBadgeClass,
      isStarted,
      getDaysUntilStart,
      getRemainingDays,
      formatDateShort,
      formatDate,
      handleCancel,
      handleDelete
    }
  }
}
</script>
